import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP3HighBudgetNew202603: FaireAdPerformancePeriodEntity = {
  token: "perf_p3_high_budget_new_202603",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-03-01",
  endDate: "2026-03-31",
  impressions: 17260,
  clicks: 246,
  adsSpendDollars: 1474,
  budgetDollars: 1500,
  salesDollars: 31843,
  bestEstimateRoas: 21.6,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.98,
  newCustomersAcquired: 13,
  dataAvailableAtDate: "2026-04-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
